<template>
    <div id="contenedor-editar-auditoria-informe">
        <v-form v-model="formularioValido" ref="editarAuditoriaInforme">
            <v-card flat>
                <v-card-title class="secondary--text mb-4">
                Editar Informe
                <v-spacer></v-spacer>
                <v-btn icon @click="cerrar">
                    <v-icon class="secondary--text" large>highlight_off</v-icon>
                </v-btn>
                </v-card-title>
                <v-card-subtitle>
                </v-card-subtitle>
                <v-card-text>
                    <v-row>
                    <div v-if="!$vuetify.breakpoint.xs"
                    style="width: 150px" class="">
                    </div>
                    </v-row>
                    <v-row>
                        <custom-text-field
                        cols="12"
                        class="pt-1"
                        v-model="informe.numeroOficio"
                        label="Número Oficio"
                        >
                        </custom-text-field>
                    </v-row>
                    <v-row>
                        <custom-text-area
                        cols="12"
                        v-model="informe.nombre"
                        label="Nombre"
                        rows="3"
                        :rules="[mixReglas.requerido]">
                        </custom-text-area>
                    </v-row>
                    <v-row>
                        <custom-date-picker
                        md="4"
                        lg="4"
                        v-model="informe.fechaRecepcion"
                        label="Recepción"
                        :rules="[mixReglas.requerido]">
                        </custom-date-picker>
                        <custom-date-picker
                        cols="12"
                        md="4"
                        lg="4"
                        v-model="informe.fechaVencimiento"
                        label="Vencimiento"
                        :rules="[mixReglas.requerido]"
                        @input="validaFechas">
                        </custom-date-picker>
                    </v-row>
                    <v-card class="selected ma-4 pa-4" flat>
                    <v-row align="center" justify="center">
                      <v-file-input
                      v-show="false"
                      show-size
                      label="Seleccionar Archivo PDF"
                      type="file"
                      ref="anexoDocumento"
                      name="anexo"
                      id="anexo"
                      accept=".pdf"
                      @change="seleccion"
                      >
                      </v-file-input>
                      <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                          <v-icon center>
                            mdi-paperclip
                          </v-icon>
                      </v-btn>
                      <template v-if="nombreArchivoSeleccionado">
                        <span class="text-caption font-weight-light secondary--text">
                          {{ nombreArchivoSeleccionado }}</span>
                      </template>
                      <template v-else>
                        <span class="text-caption font-weight-light secondary--text">
                         ... </span>
                      </template>
                    </v-row>
                    <v-row align="center" justify="center">
                      <custom-button
                          class="mx-4 text-caption font-weight-light"
                          tipo="formCancelar"
                          :label="rutaArchivo || nombreArchivoSeleccionado
                          ? 'Cambiar' : 'Seleccionar Archivo'"
                          @click="seleccionarArchivo">
                        </custom-button>
                    </v-row>
                  </v-card>
                </v-card-text>
                <v-divider class="bkground" />
                <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import mixInformes from './mixInformes';

export default {
  name: 'EditarAuditoriaInforme',
  props: {
    informeEditar: {
      type: Object,
      required: false,
    },
  },
  mixins: [mixInformes],
  components: {
    CustomButton,
    CustomTextArea,
    CustomTextField,
    CustomDatePicker,
  },
  data() {
    return {
      mostrarElegiridAuditoria: false,
      formularioValido: false,
      enviandoFormulario: false,
      rutaArchivo: null,
      nombreArchivoSeleccionado: null,
      archivoAnexo: null,
      informe: {
        numeroOficio: this.informeEditar.numeroOficio,
        nombre: this.informeEditar.nombre,
        fechaRecepcion: this.informeEditar.fechaRecepcion,
        fechaVencimiento: this.informeEditar.fechaVencimiento,
        dataFile: this.informeEditar.dataFile,
      },
      documento: {
        path: '',
        nombre: '',
      },
    };
  },
  mounted() {
    if (this.informeEditar.dataFile !== null) {
      this.nombreArchivoSeleccionado = 'PDF Informe';
    }
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarAuditoriaInforme.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      if (this.rutaArchivo !== null) {
        const archivo = await this.mixSubirArchivo(datosArchivo);
        if (archivo.status === 'ok') {
          this.informe.dataFile = JSON.stringify(archivo.data);
        }
      }
      this.mixActualizarAuditoriaInforme();
    },
    seleccion() {
      if (document.getElementById('anexo').files.length === 1) {
        this.rutaArchivo = URL.createObjectURL(
          document.getElementById('anexo').files[0],
        );
        [this.nombreArchivoSeleccionado] = document.getElementById('anexo')
          .files[0].name.split('.');
      }
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    setDatosArchivo() {
      const datos = {
        nombre: 'informe',
        path: 'Auditorias/informes/',
      };
      return datos;
    },
    validaFechas() {
      if (new Date(this.informe.fechaRecepcion) > new Date(this.informe.fechaVencimiento)) {
        this.informe.fechaVencimiento = '';
      }
    },
  },
};
</script>
